import dstyled from 'astroturf';

export default dstyled('ul')`
  @apply list-disc pl-6 mb-4;

`;
